function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgWaterOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.512 1a.5.5 0 0 1 .44.264L9.41 7.718a5.18 5.18 0 0 1-.28 5.353c-1.736 2.56-5.503 2.562-7.24 0a5.176 5.176 0 0 1-.277-5.346l3.459-6.461A.5.5 0 0 1 5.512 1Zm0 1.559-3.02 5.64a4.173 4.173 0 0 0 .225 4.31c1.34 1.976 4.247 1.976 5.588-.001a4.177 4.177 0 0 0 .225-4.316L5.512 2.559Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.205 3.337a.5.5 0 0 1 .442.266l2.865 5.438a4.22 4.22 0 0 1-.254 4.36c-.917 1.337-2.506 1.831-3.916 1.5a.5.5 0 0 1 .228-.976c1.044.246 2.201-.123 2.864-1.091.68-.99.754-2.265.195-3.325l-2.423-4.6-.308.584a.499.499 0 1 1-.883-.467l.749-1.423a.5.5 0 0 1 .441-.266Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgWaterOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgWaterOutlinedIcon);
export default Memo;